import React from "react";

import "../components/css/TransFre.css";

const TransFre = ({ totalFreq }) => {
    return(
        <>
            <div className="totalSalesDiv">
                <div className="totalSalesLabel">
                    TRANSACTION FREQUENCY
                </div>
                <div className="salesValue">
                    {totalFreq?.trim() || "0"}
                </div>
            </div>
        </>
    )
};

export default TransFre;